interface SeoProps {
  title: string;
  description: string;
  keywords?: string;
  path?: string;
}

const SITE_ORIGIN = "https://ycwgxs.com";

export default function Seo({ title, description, keywords, path = "/" }: SeoProps) {
  const url = `${SITE_ORIGIN}${path}`;
  return (
    <>
      <title>{title}</title>
      <meta name="description" content={description} />
      {keywords ? <meta name="keywords" content={keywords} /> : null}
      <link rel="canonical" href={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
    </>
  );
}